exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3kJ52JOsrdOOG57zRXrbq3 {\n  padding: 15px;\n}\n", ""]);

// Exports
exports.locals = {
	"extensionList": "_3kJ52JOsrdOOG57zRXrbq3"
};